import { render, staticRenderFns } from "./view-policy.vue?vue&type=template&id=5d18b2d8&"
import script from "./view-policy.vue?vue&type=script&lang=js&"
export * from "./view-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports